module.exports = __webpack_public_path__ + "img/mastercard.b32c1526.svg";